export { default } from './SpecPagesTags';



// WEBPACK FOOTER //
// ./src/components/SpecialPages/Common/SpecPagesTags/index.js